var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "opt_g",
      class: { opt_open: this.openedLayer === "category" },
      attrs: { id: "optCategory" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.openLayer.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "opt_selected" }, [
        _c("span", { staticClass: "tf_opt" }, [
          _c(
            "span",
            { staticClass: "txt_selected", attrs: { id: "optCateText" } },
            [_vm._v(_vm._s(_vm.categoryText[_vm.category]))]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "ico_cafetop ico_arrow" }, [
            _vm._v("옵션 더 보기"),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.openedLayer === "category",
              expression: "openedLayer === 'category'",
            },
          ],
          staticClass: "opt_layer",
          attrs: { id: "optCategory_layer" },
        },
        [
          _c(
            "ul",
            {
              staticClass: "list_opt",
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.setCategory.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "li",
                {
                  class: { on: _vm.category === "all" },
                  attrs: { id: "optCate_all" },
                },
                [_vm._v("전체분야")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.category === "musician" },
                  attrs: { id: "optCate_musician" },
                },
                [_vm._v("가수")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.category === "actor" },
                  attrs: { id: "optCate_actor" },
                },
                [_vm._v("배우")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.category === "sportsman" },
                  attrs: { id: "optCate_sportsman" },
                },
                [_vm._v("스포츠")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.category === "entertainer" },
                  attrs: { id: "optCate_entertainer" },
                },
                [_vm._v("방송인")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { on: _vm.category === "etc" },
                  attrs: { id: "optCate_etc" },
                },
                [_vm._v("기타")]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }